<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'لوحة القيادةة',
            icon: 'dashboard',
            path: '/dashboard'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-else
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
        >
        </sidebar-item>

        <!--USER-->
        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role !== 2"
          :link="{ name: 'الجداول', icon: 'people' }"
        >
          <sidebar-item
            v-if="$store.role === 1"
            :link="{ name: 'الجداول العادية', path: '/users/admin' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'الجداول الموسعة', path: '/users/student' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 4"
            :link="{ name: 'جداول البيانات صافي', path: '/users/university' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 3"
            :link="{ name: 'الجداول الموسعة', path: '/users/agency' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 5"
            :link="{ name: 'جداول البيانات صافي', path: '/users/dorm' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-else-if="$store.role !== 2"
          :link="{ name: 'User', icon: 'people' }"
        >
          <sidebar-item
            v-if="$store.role === 1"
            :link="{ name: 'Admin Users', path: '/users/admin' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Student Users', path: '/users/student' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 4"
            :link="{ name: 'University Users', path: '/users/university' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 3"
            :link="{ name: 'Agency Users', path: '/users/agency' }"
          ></sidebar-item>
          <sidebar-item
            v-if="$store.role === 1 || $store.role === 5"
            :link="{ name: 'Dorm Users', path: '/users/dorm' }"
          ></sidebar-item>
        </sidebar-item>
        <!--USER-->

        <!--UNIVERSITY-->
        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{ name: 'الجداول', icon: 'account_balance' }"
        >
          <sidebar-item
            :link="{ name: 'الجداول العادية', path: '/university' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'الجداول العادية', path: '/university' }"
          ></sidebar-item>
          <!--          <sidebar-item-->
          <!--              :link="{ name: 'الجداول الموسعة', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <!--          <sidebar-item v-if="$store.role === 2"-->
          <!--              :link="{ name: 'الجداول الموسعة', path: '/university' }"-->
          <!--          ></sidebar-item>-->
        </sidebar-item>

        <sidebar-item
          v-else
          :link="{ name: 'University', icon: 'account_balance' }"
        >
          <sidebar-item
            :link="{ name: 'Universities', path: '/university' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Programs', path: '/university/programs/list' }"
          ></sidebar-item>
          <!--          <sidebar-item-->
          <!--            :link="{ name: 'University Reviews', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <!--          <sidebar-item v-if="$store.role === 2"-->
          <!--            :link="{ name: 'My University Reviews', path: '/university' }"-->
          <!--          ></sidebar-item>-->
        </sidebar-item>
        <!--UNIVERSITY-->

        <!--APPLICATION-->
        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role === 1"
          :link="{ name: 'الجداول', icon: 'list_alt' }"
        >
          <sidebar-item
            :link="{
              name: 'الجداول العادية',
              path: '/application/decline_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول العادية',
              path: '/application/missing_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول العادية',
              path: '/application/waiting_approve_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول العادية',
              path: '/application/waiting_application_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول الموسعة',
              path: '/application/applied_list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Application', icon: 'list_alt' }"
          v-else-if="$store.role === 1"
        >
          <sidebar-item
            :link="{
              name: 'Decline/Rejected',
              icon: 'list_alt',
              path: '/application/decline_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Missing Documents',
              icon: 'list_alt',
              path: '/application/missing_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Waiting Approve',
              icon: 'list_alt',
              path: '/application/waiting_approve_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Waiting Application',
              path: '/application/waiting_application_list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Applied Application',
              path: '/application/applied_list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role !== 1"
          :link="{
            name: 'الحاجيات',
            icon: 'list_alt',
            path: '/application/list'
          }"
        ></sidebar-item>
        <sidebar-item
          v-else-if="$store.role !== 1"
          :link="{
            name: 'Application',
            icon: 'list_alt',
            path: '/application/list'
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role === 2"
          :link="{ name: 'الحاجيات', icon: 'list_alt', path: '/university' }"
        ></sidebar-item>
        <sidebar-item
          v-else-if="$store.role === 2"
          :link="{
            name: 'My Applications',
            icon: 'list_alt',
            path: '/university'
          }"
        ></sidebar-item>
        <!--APPLICATION-->

        <!--WISLIST-->
        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role === 2"
          :link="{ name: 'الحاجيات', icon: 'bookmark', path: '/university' }"
        ></sidebar-item>
        <sidebar-item
          v-else-if="$store.role === 2"
          :link="{ name: 'Wishlist', icon: 'bookmark', path: '/university' }"
        ></sidebar-item>
        <!--WISLIST-->

        <!------------------------- AGENCY ------------------------->
        <sidebar-item
          v-if="
            ($route.meta.rtlActiv && $store.role === 1) ||
              ($route.meta.rtlActiv && $store.role === 3)
          "
          :link="{ name: 'الجداول', icon: 'apartment' }"
        >
          <sidebar-item
            :link="{ name: 'الجداول العادية', path: '/agency/list' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-else-if="$store.role === 1 || $store.role === 3"
          :link="{ name: 'Agency', icon: 'apartment' }"
        >
          <sidebar-item
            :link="{ name: 'Agency', path: '/agency/list' }"
          ></sidebar-item>
        </sidebar-item>
        <!------------------------- AGENCY ------------------------->

        <!------------------------- CANDIDATE ------------------------->
        <sidebar-item
          v-if="$route.meta.rtlActiv && $store.role === 1"
          :link="{ name: 'الجداول', icon: 'person' }"
        >
          <sidebar-item
            :link="{ name: 'الجداول العادية', path: '/candidate-form/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول العادية',
              path: '/candidate-form/finished_list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-else-if="$store.role === 1"
          :link="{ name: 'Candidate Forms', icon: 'person' }"
        >
          <sidebar-item
            :link="{ name: 'Candidate Forms', path: '/candidate-form/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Finished Candidate Forms',
              path: '/candidate-form/finished-list'
            }"
          ></sidebar-item>
        </sidebar-item>
        <!------------------------- CANDIDATE ------------------------->

        <!--DORM-->
        <!--        <sidebar-item v-if="$route.meta.rtlActiv" :link="{ name: 'الجداول', icon: 'night_shelter' }">-->
        <!--          <sidebar-item-->
        <!--              :link="{ name: 'الجداول العادية', path: '/dorm/list' }"-->
        <!--          ></sidebar-item>-->
        <!--          <sidebar-item-->
        <!--              :link="{ name: 'الجداول الموسعة', path: '/university' }"-->
        <!--          ></sidebar-item>-->
        <!--          <sidebar-item v-if="$store.role === 2"-->
        <!--              :link="{ name: 'الجداول الموسعة', path: '/university' }"-->
        <!--          ></sidebar-item>-->
        <!--        </sidebar-item>-->

        <!--        <sidebar-item v-else :link="{ name: 'Dorm', icon: 'night_shelter' }">-->
        <!--          <sidebar-item-->
        <!--            :link="{ name: 'Dorms', path: '/dorm/list' }"-->
        <!--          ></sidebar-item>-->
        <!--          <sidebar-item-->
        <!--            :link="{ name: 'Dorm Reviews', path: '/university' }"-->
        <!--          ></sidebar-item>-->
        <!--          <sidebar-item v-if="$store.role === 2"-->
        <!--            :link="{ name: 'My Dorm Reviews', path: '/university' }"-->
        <!--          ></sidebar-item>-->
        <!--        </sidebar-item>-->
        <!--DORM-->

        <!--LOCATION-->
        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role === 1"
          :link="{ name: 'الجداول', icon: 'location_on' }"
        >
          <sidebar-item
            :link="{ name: 'الجداول العادية', path: '/location/country/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'الجداول الموسعة', path: '/location/city/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'الجداول الموسعة', path: '/location/place/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'الجداول الموسعة',
              path: '/location/transportation/list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-else-if="$store.role === 1"
          :link="{ name: 'Location', icon: 'location_on' }"
        >
          <sidebar-item
            :link="{ name: 'Country', path: '/location/country/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'City', path: '/location/city/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Place', path: '/location/place/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Transportation',
              path: '/location/transportation/list'
            }"
          ></sidebar-item>
        </sidebar-item>
        <!--LOCATION-->

        <!--OTHER-->
        <sidebar-item
          v-if="$route.meta.rtlActive && $store.role === 1"
          :link="{ name: 'الجداول', icon: 'article' }"
        >
          <!--          <sidebar-item-->
          <!--              :link="{ name: 'الجداول العادية', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <!--          <sidebar-item-->
          <!--              :link="{ name: 'الجداول الموسعة', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <sidebar-item
            :link="{ name: 'الجداول الموسعة', path: '/application/season/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Announcement',
              path: '/university/announcement/list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Article',
              path: '/article/list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-else-if="$store.role === 1"
          :link="{ name: 'Other', icon: 'article' }"
        >
          <!--          <sidebar-item-->
          <!--            :link="{ name: 'Article', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <!--          <sidebar-item-->
          <!--            :link="{ name: 'FAQ', path: '/university' }"-->
          <!--          ></sidebar-item>-->
          <sidebar-item
            :link="{ name: 'Season', path: '/application/season/list' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Announcement',
              path: '/university/announcement/list'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Article',
              path: '/article/list'
            }"
          ></sidebar-item>
        </sidebar-item>
        <!--OTHER-->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

<!--      <fixed-plugin-->
<!--        :color.sync="sidebarBackground"-->
<!--        :colorBg.sync="sidebarBackgroundColor"-->
<!--        :sidebarMini.sync="sidebarMini"-->
<!--        :sidebarImg.sync="sidebarImg"-->
<!--        :image.sync="sidebarBackgroundImage"-->
<!--      >-->
<!--      </fixed-plugin>-->

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    // FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "azure",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: false,
      sidebarImg: true
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
